import * as React from "react";
import type { SVGProps } from "react";
const SvgCertificate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 19H5c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v10c0 1.07-.58 2.06-1.5 2.6-.48.28-1.09.11-1.37-.36-.28-.48-.11-1.09.36-1.37.31-.18.5-.51.5-.87V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h5c.55 0 1 .45 1 1s-.45 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 16.647A3.999 3.999 0 0 1 15 10a3.999 3.999 0 0 1 3 6.646V21c0 .38-.21.72-.55.89-.14.07-.29.11-.45.11-.21 0-.42-.07-.6-.2L15 20.75l-1.4 1.05c-.3.23-.71.26-1.05.09A1 1 0 0 1 12 21zm2 1.227a4 4 0 0 0 2 0V19l-.4-.3a.99.99 0 0 0-1.2 0l-.4.3zM13 14c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6 9h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1M9 12H6c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1M6 15h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1"
    />
  </svg>
);
export default SvgCertificate;
